import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from './Navbar';

export default function NotFound() {
  return (
    <>
      <Navbar />
      <section className="section bg-white">
        <div className="container py-5 text-center">
          <h1 className="fw-bold mb-2">Halaman tidak ditemukan</h1>
          <p className="text-muted mb-4">Link yang Anda buka mungkin sudah berubah atau tidak tersedia.</p>
          <div className="d-flex justify-content-center gap-2 flex-wrap">
            <Link to="/" className="btn btn-success">
              Kembali ke Home
            </Link>
            <Link to="/blog" className="btn btn-outline-success">
              Lihat Blog
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
